/**
 * Runtime Layer Checkpoint
 * 
 * Logs layer completion to console and sets a data attribute on #root.
 * Enabled only when REACT_APP_RUNTIME_DIAGNOSTICS=1.
 * 
 * NO UI CHANGES. NO CONTROL FLOW CHANGES.
 */

const DIAGNOSTICS_ENABLED = process.env.REACT_APP_RUNTIME_DIAGNOSTICS === '1';

export function renderCheckpoint(layerId, layerName) {
    if (!DIAGNOSTICS_ENABLED) return;

    const timestamp = new Date().toISOString();
    const message = `[LAYER ${layerId}] ${layerName} - ${timestamp}`;

    // Console signal
    console.log(`✓ ${message}`);

    // DOM signal (non-visual, for automated detection)
    const root = document.getElementById('root');
    if (root) {
        root.setAttribute(`data-layer-${layerId}`, 'complete');
        root.setAttribute('data-highest-layer', layerId);
    }
}
